export enum UserRoles {
    CLIENT = 'CLIENT',
    THERAPIST = 'THERAPIST',
    PRACTICE_ADMIN = 'PRACTICE_ADMIN',
    SCHEDULER = 'SCHEDULER',
    TENANT_SUPER_ADMIN = 'TENANT_SUPER_ADMIN',
  }

  export enum UserTypes {
    CLIENT = 'CLIENT',
    STAFF = 'STAFF',
  }
  